<template>
    <DashboardShell v-model:show-welcome="showWelcomeDialog"
                    :nav-items="menuItems"
                    :missing-params="missingParams"
                    :exporting="exporting"
                    :welcome="{
                        projectName,
                        initializing: !isDuckDBInitialized,
                        dataLoaded,
                        apiProgress,
                        totalApiRequests,
                        queryString,
                        showMarketingPanel: SHOW_WELCOME_MARKETING_PANEL,
                        contained: false,
                    }"
                    @load="handleLoadDashboard"
                    @copy-query-string="handleCopyQueryString"
                    @export="exportDatabase"
                    @toggle-theme="toggleTheme"
                    @close-missing-params="handleMissingParams">
        <template #default>
            <router-view @itemsUpdated="handleItemsUpdated"></router-view>
        </template>

        <template #fab>
            <StatusFilterFab v-model="showFilterDialog"
                             :theme="currentTheme"
                             :status-templates="statusTemplates"
                             :status-filters="statusFilters"
                             :has-active-filter="hasActiveFilter"
                             :all-filters-selected="allFiltersSelected"
                             :extra-toggles="extraToggles"
                             :extra-toggle-values="extraToggleValues"
                             @toggle-status="toggleStatus"
                             @toggle-all="toggleAll"
                             @toggle-extra="toggleExtra" />
        </template>
    </DashboardShell>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
